<template>
	<div class="main--content" id="PageRentalTypes">
		<div class="container content-rental">
			<div class="row">
				<div class="col-12">
					<div class="wrapper-headlines">
						<div class="row justify-content-center">
							<div class="col-md-12 col-lg-auto">
								<h1 class="d-inline-block" v-if="payment_verified">{{ $t('Rechnungsempfänger') }}</h1>
								<h1 class="d-inline-block" v-else >{{ $t('Bemerkungen zur Fahrt') }}</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>
					<div class="row justify-content-center align-items-center" v-if="rentaltypes.length !== 0">
						<div class="col-sm-auto">
		
							<div v-for="(item, index) in rentaltypes">
								<CsInputRadio
									:ischecked="{'checked': index === 0}"
									type="Radio"
									autocomplete="pricelist_id"
									:value="item.pricelist_id"
									:validate="{'required':true}"
									:id="item.pricelist_id"
									:name="'pricelist'"
									:label="item.rental_type_description"
									v-model="pricelist"
									v-if="payment_verified"
								></CsInputRadio>
							</div>
							<div>
							</div>
							<CsTextarea
								:placeholder="$t('Bemerkungen zur Fahrt')"
								:prefilled="comment"
								:validate="{'required':comment_requiered}"
								:id="'comment'"
								:name="'comment'"
								:rows="3"
								v-model="comment"
							></CsTextarea>
							<button @click="nextPage" type="button" class="btn btn-primary btn-wp">
								{{ $t('Continue to vehicle selection') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import { mapGetters } from 'vuex';
export default {
	name: 'PageRentaltypes',
	data() {
		return {
			rentaltypes: [],
			payment_verified: false,
			pricelist: '',
			comment: this.$store.getters['orm/reservation/rentalcomment'],
			comment_requiered: false,
		};
	},
	computed: {
	    ...mapGetters('orm/reservation', [
	    	'user_session',
			'station',
	    ]),
	    // map core functions
	    ...mapGetters('orm', [
	      'stations'
	    ]),
	},
	watch: {
		pricelist: function (val) {
			if (val == this.rentaltypes[0].pricelist_id)	{
				this.comment_requiered = true;
			}else{
				this.comment_requiered = false;
			}
		},
			
	},
	mounted() {
		var self = this;

		console.log(this.$store.getters['orm/reservation/rentalcomment']);
		
		this.$store.dispatch('orm/GET_CUSTOMER')
		.then(result => {

			self.payment_verified = true;//result.payment_verified;

			if (!self.payment_verified){
				this.comment_requiered = true;
			} 


			this.$store.dispatch('orm/reservation/GET_RENTALTYPES')
			.then(result => {
				console.log(result.result[0].pricelist_id);
				self.pricelist = result.result[0].pricelist_id;
				self.rentaltypes = result.result;

			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		

		
	},
	methods: {
		nextPage(){

			this.$store.getters['orm/reservation/startstation'].private_reservations

			this.$validator.validateAll().then(valid => {
				if (valid) {
					this.$store.commit('orm/reservation/UNSET_RENTALTYPE');
					if(this.pricelist == "PRIVAT"){
						this.pricelist = 0;
					}
					this.$store.commit('orm/reservation/SET_RENTALTYPE', this.pricelist);
					this.$store.commit('orm/reservation/SET_RENTALCOMMENT', this.comment);

					console.log(this.pricelist);

					if(!this.user_session) {
						this.$router.push({name: "PageLogin", params: {redirect: 'PageCar' }});
					} else {
							this.$router.push({
							name: 'PageCar'
						});
					}

					

				// do stuff if valid.
				}else{
					//this.$validator.errors.add({field: 'pin', msg: '', vmId: this.$validator.id });
				}	
			});


		/* 	
if(!this.user_session) {
						this.$router.push({name: "PageLogin", params: {redirect: 'PageCar' }});
					} else {
							this.$router.push({
							name: 'PageCar'
						});
					}
			
			 */


		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/Pages/PageRentaltypes.vue